import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import PrefacturasItemStatus from './components/PrefacturasItemStatus';

class PrefacturaList extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: []
    }
  }

  get columns() {
    return [
      {
        align: 'center',
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: (item) => <PrefacturasItemStatus data={ item } />
      },
      {
        key: 'version',
        title: 'Versión',
        render: (item) => item.field.input?.Version
      },
      {
        key: 'created_at',
        title: 'Fecha',
        dataIndex: 'created_at',
      },
      {
        key: 'tipo',
        title: 'Tipo',
        dataIndex: 'tipo',
      },
      {
        key: 'emisor_rfc',
        title: 'Emisor',
        dataIndex: 'emisor_rfc',
      },
      {
        key: 'receptor_rfc',
        title: 'Receptor',
        dataIndex: 'receptor_rfc',
      },
      {
        key: 'metodo_de_pago',
        title: 'M. Pago',
        render: (item) => item.field.input?.MetodoPago
      },
      {
        key: 'forma_de_pago',
        title: 'F. Pago',
        render: (item) => item.field.input?.FormaPago
      },
      {
        key: 'total',
        title: 'Total',
        dataIndex: 'total',
      },
    ];
  }

  async componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      this.paginate({
        page: 1,
        from,
        to
      });
    }
  }

  paginate(meta = {}) {
    const { filters } = this.props;

    this.props.paginate({
      ...filters,
      ...meta
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  }

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  }

  handleRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRows,
      selectedRowKeys
    }, () => {
      const { onRowSelectionChange } = this.props;

      onRowSelectionChange && onRowSelectionChange({selectedRowKeys, selectedRows});
    });
  }

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange
    }
  }

  render() {
    const { columns } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    return (
      <Table
        loading={ busy }
        columns={ columns }
        rowKey={ 'id' }
        data={ data }
        pagination={ this.getPaginationConfig() }
        onRowClick={ onRowClick }
        onRow={ (item) => {
            return {
              className: item.highlight ? 'row-highlighted' : ''
            }
          }
        }
      >
      </Table>
    )
  }
}

const mapState = (state) => {
  return state.app.prefacturas.list;
}

const mapActions = (actions) => {
  return {
    paginate: actions.app.prefacturas.list.paginate
  };
}

export default connect(useStore, mapState, mapActions)(PrefacturaList);